import { useEffect, useState, useCallback } from 'react';
import { Affix, Form } from 'antd';
import { Button, message } from 'antd';
import { useParams } from 'react-router-dom';

import AppHeader from 'components/AppHeader';
import managerApis from 'api/managerApis';
import ManagerForm from './components/form';

export default function DetailManagerPage() {
  let { managerId } = useParams();
  const [manager, setManager] = useState({});
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const response = await managerApis.detail(managerId);

      if (response.code == 200) {
        const data = response.data;
        setManager(data);
        form.setFieldsValue({
          ...data
        });
      } else {
        message.error(response.message ?? 'Đã có lỗi');
      }
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handleOnSubmit = async () => {
    setIsLoading(true);
    let data = form.getFieldsValue();
    console.log(data)
    try {
      const res = await managerApis.update(manager.id, data);
      if (res.code == 200) {
        message.success(res.message);
        // window.location.reload();
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error(error.message);
    }
    setIsLoading(false);
  };

  const validateData = () => {
    form
      .validateFields()
      .then(() => {
        handleOnSubmit();
      })
      .catch((info) => {
        const errorMsg = 'Validate Failed: ' + info.errorFields[0].errors[0];
        form.scrollToField(info.errorFields[0].name, {
          behavior: 'smooth',
          block: 'center'
        });
        message.error(errorMsg);
      });
  };
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle={`Cập nhật Manager (ID ${manager.id})`}
        pageHeaderExtras={[
          <Button type="primary" onClick={validateData} loading={isLoading}>
            Cập nhật
          </Button>
        ]}
      />

      <ManagerForm
        form={form}
        manager={manager}
      />

    </>
  );
}
